import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ManageHeader from "@components/ManageHeader";
import { Camera } from "lucide-react";
import FormAddImage from "./forms/FormAddImage";
import Gallery from "./components/Gallery";
import { apiSend, getRoute } from "@services/axios";
const Album = (props) => {
  const { t } = useTranslation();
  const productId = useParams().id;
  const [imageList, setImageList] = useState([]);

  const loadAlbum = async () => {
    const response = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), "album", productId].join("/"),
      "get"
    );
    setImageList(response?.data?.result);
  };

  useEffect(() => {
    const timerId = setTimeout(async () => {
      await loadAlbum();
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <>
      <ManageHeader
        title={t("add_photos")}
        content={t("photos_text")}
        icon={<Camera size={25} strokeWidth={1.5} />}
      />
      <hr />
      <div className="text-right">
        {" "}
        <FormAddImage productId={productId} loadAlbum={loadAlbum} />
      </div>
      <div className="container">
        {" "}
        <Gallery images={imageList} />
      </div>
    </>
  );
};

export default Album;
